import styled from "styled-components";

const IconWrapper = styled.div`
  display: ${(props) => (props.isExtended ? "none" : "flex")};
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.clearGray};
  background-color: ${(props) => props.theme.colors.white};
`;

const Title = styled.h1`
  margin-top: 16px;
  margin-bottom: 8px;
  font-family: ${(props) => props.theme.fonts?.family?.inter || 'Inter, sans-serif'};
  font-weight: 600;
  font-size: 1.5rem;
  color: ${(props) => props.theme.colors.clearBlue};
  text-align: ${(props) => (props.isExtended ? "center" : "left")}; 
`;

const Message = styled.p`
  font-family: ${(props) => props.theme.fonts?.family?.inter || 'Inter, sans-serif'};
  font-weight: 400;
  font-size: 1rem;
  margin: 0px;
  padding: 0px;
  text-align: center;
`;

export {
  Title,
  Message,
  IconWrapper
};